import React, { Fragment } from "react";
import { bool, object, oneOfType, shape, string } from "prop-types";
import { Button, Card, Modal, Spinner } from "react-bootstrap";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles/EditModal.module.css";
import { updateUserActiveAction } from "@redux/modules/user/slices";

const EditModal = ({ data, handleClose }) => {
  // state

  // variables
  let spinner = null;
  let spinnerVisible = false;
  const { id, fullName, isActive } = data;
  let statusName;
  let statusVariant;
  switch (isActive) {
    case true:
      statusName = "Active";
      statusVariant = "success";
      break;
    case false:
      statusName = "Block";
      statusVariant = "danger";
      break;
  }

  // logics before hooks

  // hooks
  const { updateUser } = useSelector((state) => state.user);
  spinnerVisible = updateUser.processing;
  const dispatch = useDispatch();

  // logics
  const handleChangeStatus = (newStatus) => {
    dispatch(
      updateUserActiveAction({
        data: { id: id, isActive: newStatus },
        onSuccess: () => {
          handleClose();
        },
      })
    );
  };

  // UI partials
  if (spinnerVisible)
    spinner = (
      <div className={styles.spinner}>
        <div className="text-center">
          <Spinner animation="border" variant="danger" />
          <div className="text-danger">Processing...</div>
        </div>
      </div>
    );

  // effects

  // render
  return (
    <Fragment>
      <Modal.Header closeButton>
        <Modal.Title>Update User Status</Modal.Title>
      </Modal.Header>
      <Modal.Body className="position-relative">
        {spinner}
        <Card.Body className="p-0">
          <Card.Title>
            <strong className={`text-${statusVariant} mr-2`}>
              ({statusName})
            </strong>
            {fullName}
          </Card.Title>
        </Card.Body>
      </Modal.Body>
      <Modal.Footer>
        {isActive === true ? (
          <Fragment>
            <Button
              // disabled={courseStatusChanger.processing}
              variant="danger"
              onClick={() => handleChangeStatus(false)}
            >
              Block
            </Button>
          </Fragment>
        ) : null}
        {isActive === false ? (
          <Fragment>
            <Button variant="success" onClick={() => handleChangeStatus(true)}>
              UnBlock
            </Button>
          </Fragment>
        ) : null}
      </Modal.Footer>
    </Fragment>
  );
};

/* required: display name */
EditModal.displayName = "EditModal";

/* required: props types */
EditModal.propTypes = {
  data: shape({
    id: string,
    title: string,
    user: shape({ id: string, fullName: string }),
    createdAt: oneOfType([string, object]),
    category: shape({ name: string, id: string }),
    status: bool,
  }),
};

/* required: default props */
EditModal.defaultProps = {
  data: {
    id: "",
    title: "",
    user: { id: "", fullName: "" },
    createdAt: moment(),
    category: { name: "", id: "" },
    status: false,
  },
};

export { EditModal };
